import { ErpWorkflowHistoryTestComponent } from './component/erpworkflowhistorytest.component';
import { ErpWorkflowTestformComponent } from './component/erpworkflowtestform.component';
import { Routes, RouterModule } from '@angular/router';
import { HisAuthGuard, HisBootstrapService } from 'hisng';

export const ROUTE_CONFIG: Routes = [
    {
        // Workflowtest
        path: 'workflow/workflowtest',
        resolve: { boot: HisBootstrapService },
        component: ErpWorkflowTestformComponent,
        canActivate: [HisAuthGuard],
        data: {
            hasAll: ['RIGHT_EVERYONE'],
            modules: ['HISINONEZEB']
        }
    },
    {
        // Workflowhistorytest
        path: 'workflow/workflowhistorytest',
        resolve: { boot: HisBootstrapService },
        component: ErpWorkflowHistoryTestComponent,
        canActivate: [HisAuthGuard],
        data: {
            hasAll: ['RIGHT_EVERYONE'],
            modules: ['HISINONEZEB']
        }
    }
];

// eslint-disable-next-line @typescript-eslint/naming-convention
export const ErpWorkflowRoutesModule = RouterModule.forChild( ROUTE_CONFIG );
